module.exports = __webpack_public_path__ + "static/media/10ю09.06b706d6.webp";